// extracted by mini-css-extract-plugin
export const root = "figure-module--root--1FgYF";